export const ProgramTopics = ({ topics, patronLabel, itemIndex }) => (
  <div
    className="mt-5 grid min-w-0 grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2 max-w-3xl"
    data-testid={`program-item-topics-${itemIndex}`}
  >
    {topics.map((topic, index) => {
      const testId = `program-topic-${itemIndex}-${index}`;
      const isLastOdd = topics.length % 2 === 1 && index === topics.length - 1;
      return (
        <div
          key={topic.title}
          data-testid={testId}
          className={`flex min-w-0 flex-col bg-[#01154F] px-4 py-5 sm:px-5 [overflow-wrap:anywhere] ${isLastOdd ? "md:col-span-2" : ""}`}
        >
          <h5 data-testid={`${testId}-title`} className="font-display font-bold text-[#CEA26B] text-base leading-snug">
            {topic.title}
          </h5>
          {topic.q && (
            <p data-testid={`${testId}-question`} className="mt-2 text-sm text-slate-200 leading-relaxed">{topic.q}</p>
          )}
          {topic.text && (
            <p data-testid={`${testId}-description`} className="mt-2 text-sm text-slate-400 leading-relaxed">{topic.text}</p>
          )}
          {topic.patron && (
            <div className="mt-auto pt-5">
              <p data-testid={`${testId}-patron`} className="flex flex-wrap items-center gap-x-4 gap-y-3 border-t border-[#CEA26B]/30 pt-3 text-sm">
                <span className="text-slate-300">{patronLabel}:</span>
                {topic.patronLogo && topic.patronUrl ? (
                  <a
                    href={topic.patronUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${topic.patron} — ${patronLabel}`}
                    data-testid={`${testId}-patron-link`}
                    className="flex w-36 max-w-full aspect-[2/1] items-center justify-center bg-white px-3 py-2 hover:bg-[#CEA26B]/10 focus:outline-none focus:ring-2 focus:ring-[#CEA26B] transition-colors"
                  >
                    <img
                      data-testid={`${testId}-patron-logo`}
                      src={topic.patronLogo}
                      alt={topic.patron}
                      loading="lazy"
                      className="h-full w-full object-contain"
                    />
                  </a>
                ) : topic.patronLogo ? (
                  <span className="flex w-36 max-w-full aspect-[2/1] items-center justify-center bg-white px-3 py-2">
                    <img
                      data-testid={`${testId}-patron-logo`}
                      src={topic.patronLogo}
                      alt={topic.patron}
                      loading="lazy"
                      className="h-full w-full object-contain"
                    />
                  </span>
                ) : (
                  <strong className="font-display font-bold text-[#CEA26B] text-base">{topic.patron}</strong>
                )}
              </p>
            </div>
          )}
        </div>
      );
    })}
  </div>
);